import React, { useEffect, useState, useRef  } from 'react';
import './ChallengeList.scss';
import ChallengeCarousel from '../challengeCarousel/ChallengeCarousel';
import { useDispatch, useSelector } from 'react-redux';
import { fetchChallengeList, fetchChallengeProfile, fetchChallengeTeamDetail, fetchBeginChallengeTeamDetail } from '../../../actions';
import { CHALLENGE, CHALLENGE_LIST } from '../../../common/challengeConstants';
import ChallengeDefault from './ChallengeDefault';
import { getDataFromSession, getParamsString, isEmptyObject } from '../../../utill.func';
import HnwFooter from '../../../common/hnwFooter/HnwFooter';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { commonConstant } from '../../../common';
import { 
  FETCH_CHALLENGES_DETAIL_SUCCESS, 
  FETCH_CHALLENGES_PROFILE_SUCCESS, 
  SET_FOOTER_STATE_CHALLENGE, 
  FETCH_BEGIN_CHALLENGES_DETAIL_SUCCESS,
  FETCH_BEGIN_CHALLENGES_PROFILE_SUCCESS 
} from '../../../actions/types';
import { setChallengeType } from '../../../actions/hnwFooterAction';

const ChallengeDetails = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isProfileLoading, setIsProfileLoading] = useState(false);

  const hasFetchedProfile = useRef(false);
  const hasFetchedBodyKeyTeamDetail = useRef(false);
  const hasFetchedBeginTeamDetail = useRef(false);

  const challengeList = useSelector(
    (state) => state.challengeListObj?.challengeList
  );
  const challengeProfileList = useSelector(
    (state) => state.challengeListObj?.challengeProfile?.profileList
  );
  const { teamData } = useSelector(
    (state) => state.challengeTeamDashboard,
  );

  const beginChallengeProfileList = useSelector(
    (state) => state.challengeListObj?.beginChallengeProfile?.profileList
  );

  const { teamData: beginTeamData } = useSelector(
    (state) => state.beginChallengeTeamDashboard || {},
  );

  const { isAuthTokenSaved } = useSelector(
    (state) => state.tokenStatus,
  );
  const { policyStatus } = useSelector((state) => state.home);

  const upcomingChallenge = challengeList?.upcoming;
  const ongoingChallenge = challengeList?.ongoing;

  const noChallenge =
    (!upcomingChallenge || upcomingChallenge.length === 0) &&
    (!ongoingChallenge || ongoingChallenge.length === 0);

  useEffect(() => {
    const fetchChallenge = async (type) => {
      setIsLoading(true);
      const paramsObj = {
        challengeStatus: type,
      };
      await dispatch(fetchChallengeList(paramsObj));
      setIsLoading(false);
    };

    const fetchProfile = async (eventIdList) => {
      const { partyId, amwayNumber } = getDataFromSession(
        'customer'
      );
      const payloadObj = {
        partyId,
        aboId: amwayNumber,
        eventIds: eventIdList
      }
      setIsProfileLoading(true);
      await dispatch(fetchChallengeProfile(`?${getParamsString(payloadObj)}`));
      setIsProfileLoading(false);
    }

    if (!challengeList?.ongoing && isAuthTokenSaved) {
      fetchChallenge('ongoing');
    }
    if (!challengeList?.upcoming && isAuthTokenSaved) {
      fetchChallenge('upcoming');
    }
    if (ongoingChallenge?.length > 0 && !challengeProfileList && isAuthTokenSaved && !hasFetchedProfile.current) {
      hasFetchedProfile.current = true;
      const eventIdList = ongoingChallenge
        .filter((challenge) => challenge.eventId)
        .map((challenge) => challenge.eventId)
        .join(',');
      fetchProfile(eventIdList);
    }
  }, [challengeList, isAuthTokenSaved]);

  useEffect(() => {
    dispatch(setChallengeType(SET_FOOTER_STATE_CHALLENGE));
  }, [])

  useEffect(() => {
    if (challengeProfileList?.length && isEmptyObject(teamData) && !hasFetchedBodyKeyTeamDetail.current) {
      hasFetchedBodyKeyTeamDetail.current = true;   
      const { partyId, amwayNumber } = getDataFromSession('customer');
      dispatch(fetchChallengeTeamDetail({
        amwayNumber: amwayNumber,
        partyId,
        challengeId: challengeProfileList[0].id,
      }, challengeList?.ongoing));
    }

      //for begin challenge
       if (beginChallengeProfileList?.length && isEmptyObject(beginTeamData) && !hasFetchedBeginTeamDetail.current) {
        hasFetchedBeginTeamDetail.current = true;   
        const { partyId, amwayNumber } = getDataFromSession('customer');
        dispatch(fetchBeginChallengeTeamDetail({
          amwayNumber,
          partyId,
          challengeId: beginChallengeProfileList[0].id,
        }, challengeList?.ongoing));
      }
  }, [challengeProfileList, beginChallengeProfileList])

  useEffect(() => {
    if (teamData?.challengeType && challengeProfileList?.length
      && (challengeProfileList[0]?.challengeType?.toLowerCase() !== teamData?.challengeType?.toLowerCase() || 
      !challengeProfileList[0]?.tagStatus)) {
      const updatedChallengeList = JSON.parse(JSON.stringify(challengeProfileList));
      updatedChallengeList[0] = {
        ...updatedChallengeList[0],
        tagStatus: teamData.teamDashboardStatus,
        challengeType: teamData.challengeType.toLowerCase(),
        maxTeamSize: teamData.teamFullSize
      };

      dispatch({
        type: FETCH_CHALLENGES_PROFILE_SUCCESS,
        payload: updatedChallengeList
      })
    }
  }, [teamData, challengeProfileList])

    useEffect(() => {
    if (beginTeamData?.challengeType && beginChallengeProfileList?.length
      && (beginChallengeProfileList[0]?.challengeType?.toLowerCase() !== beginTeamData?.challengeType?.toLowerCase() || 
      !beginChallengeProfileList[0]?.tagStatus)) {
      const updatedChallengeList = JSON.parse(JSON.stringify(beginChallengeProfileList));
      updatedChallengeList[0] = {
        ...updatedChallengeList[0],
        tagStatus: beginTeamData.teamDashboardStatus,
        challengeType: beginTeamData.challengeType.toLowerCase(),
        maxTeamSize: beginTeamData.teamFullSize
      };

      dispatch({
        type: FETCH_BEGIN_CHALLENGES_PROFILE_SUCCESS,
        payload: updatedChallengeList
      })
    }
  }, [beginTeamData, beginChallengeProfileList])

  useEffect(() => {
    if (beginTeamData?.challengeType && beginChallengeProfileList?.length
      && (beginChallengeProfileList[0]?.challengeType?.toLowerCase() !== beginTeamData?.challengeType?.toLowerCase() ||
      !beginChallengeProfileList[0]?.tagStatus)) {
      const updatedBeginChallengeList = JSON.parse(JSON.stringify(beginChallengeProfileList));
      updatedBeginChallengeList[0] = {
        ...updatedBeginChallengeList[0],
        tagStatus: beginTeamData.teamDashboardStatus,
        challengeType: beginTeamData.challengeType.toLowerCase(),
        maxTeamSize: beginTeamData.teamFullSize
      };

      dispatch({
        type: FETCH_BEGIN_CHALLENGES_PROFILE_SUCCESS,
        payload: updatedBeginChallengeList
      })
    }
  }, [beginTeamData, beginChallengeProfileList])

  const handleCardClick = async (cardObj, isRegistered, challengeType) => {
    const { id, eventId, challengeStatus: type, completeDate, teamDashboardImage } = cardObj;
    const { partyId } = getDataFromSession('customer');
    // TODO: need to store in localstorage for camera screen's navigate back
    await dispatch({
      type: FETCH_CHALLENGES_DETAIL_SUCCESS,
      payload: cardObj,
    });
    sessionStorage.setItem("challengeData", JSON.stringify({ challengeId: eventId, challengeEventId: id, challengeRewardDate: completeDate, myDashboardBg: teamDashboardImage, eventType: challengeType }));
    let paramsObj = {};
    if (type === CHALLENGE_LIST.TYPES.upcoming || (type === CHALLENGE_LIST.TYPES.ongoing && !isRegistered)) {
      paramsObj = {
        challengeId: id,
        isRegistered
      }
      history.push(`${commonConstant.pathChallengeDetail}?${getParamsString(paramsObj)}`);
    }
    else if (type === CHALLENGE_LIST.TYPES.ongoing && isRegistered) {
      paramsObj = {
        challengeId: eventId,
        eventId: id,
        partyId
      }
      let routePath = commonConstant.pathChallengeTeamDashboard;
      if (challengeType?.toUpperCase() === CHALLENGE.type.ME) {
        routePath = commonConstant.pathChallengeMyDashboard;
      }
      history.push(`${routePath}?${getParamsString(paramsObj)}`);
    }
  }

  const handleBeginChallengeClick = async (cardObj, isRegistered, challengeType) => {
    const { id, eventId, challengeStatus: type, completeDate, teamDashboardImage } = cardObj;
    const { partyId } = getDataFromSession('customer');

    //set selected begin challenge in challengelist reducer
    await dispatch({
      type: FETCH_BEGIN_CHALLENGES_DETAIL_SUCCESS,
      payload: cardObj,
    });

    //set session storage with begin challenge details
    sessionStorage.setItem("beginChallengeData", JSON.stringify({ challengeId: eventId, challengeEventId: id, challengeRewardDate: completeDate, teamDashboardImg: teamDashboardImage, eventType: challengeType }));

    let paramsObj = null;
    let routePath = null
    if (type === CHALLENGE_LIST.TYPES.ongoing) {
      //if challenge is ongoing and user is not registered redirect to detail screen else to dashboard
      paramsObj = {
        challengeId: eventId,
        eventId: id,
        partyId,
        isRegistered
      }
      if(!isRegistered){ 
        routePath = commonConstant.pathBeginChallengeDetail;
      }else{
        routePath = commonConstant.pathBeginChallengeTeamDashBoard;
      }
      history.push(`${routePath}?${getParamsString(paramsObj)}`);
    }else if(type === CHALLENGE_LIST.TYPES.upcoming){
      paramsObj = {
        challengeId: id,
        isRegistered
      }
      routePath = commonConstant.pathBeginChallengeDetail;
      history.push(`${routePath}?${getParamsString(paramsObj)}`);
    }
  };

  return (
    <div>
      {!isLoading && noChallenge ? (
        <ChallengeDefault policyStatus={policyStatus} />
      ) : (
        <>
          <div className="challenge-list-main">
            <ChallengeCarousel
              title={CHALLENGE_LIST.TITLE_MAP.ongoing}
              carouselList={challengeList?.ongoing}

              isLoading={isLoading}
              challengeProfileList={challengeProfileList}
              isProfileLoading={isProfileLoading}
              showTag
              onCardClick={handleCardClick}
              beginChallengeProfileList={beginChallengeProfileList}
              onBeginChallengeClick={handleBeginChallengeClick}
            />
            <ChallengeCarousel
              title={CHALLENGE_LIST.TITLE_MAP.upcoming}
              carouselList={challengeList?.upcoming}

              isLoading={isLoading}
              onCardClick={handleCardClick}
              challengeProfileList={challengeProfileList}
              beginChallengeProfileList={beginChallengeProfileList}
              onBeginChallengeClick={handleBeginChallengeClick}
            />
          </div>
          <HnwFooter policyStatus={policyStatus} />
        </>
      )}
    </div>
  );
};

export default ChallengeDetails;
